<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="临时停车费" subheading="" />
      <a @click="toModifyConfig" v-if="permissionCodes.indexOf('004015001') !== -1">修改</a>
    </div>
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">单价：</span>
        </div>
        <el-input v-model="unitPrice" size="small" style="width: 280px" disabled>
          <template slot="append">元 / 小时</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">免费时长：</span>
        </div>
        <el-input v-model="freeTime" size="small" style="width: 280px" disabled>
          <template slot="append">分钟</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计费是否包含免费时长：</span>
        </div>
        <el-switch v-model="realFree" active-text="是" inactive-text="否" disabled></el-switch>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">封顶收费：</span>
        </div>
        <el-input v-model="maxParkingFee" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" :row="3" v-model="memo" size="small" style="width: 280px" disabled/>
      </div>
    </form>
  </div>
</template>

<script>
import { errorHandler } from "../../../utils/errorHandler";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { api } from "../../api/ParkingService";
import TextTitle from "../../../components/Text/TextTitle";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TextTitle,
    Breadcrumb
  },
  name: "parking-config-center",
  data() {
    return {
      permissionCodes: "",
      config: {
        breadcrumb: [
          {
            value: "智慧停车",
            name: "park-yard"
          },
          {
            value: "缴费配置"
          }
        ]
      },
      code: "",
      unitPrice: "",
      freeTime: "",
      realFree: false,
      maxParkingFee: "",
      memo: ""
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getParkingPaymentConfigList();
  },
  methods: {
    toModifyConfig() {
      this.$router.push({
        name: "parking-temporary-config-modify",
        params: {
          code: this.code,
          unitPrice: this.unitPrice,
          freeTime: this.freeTime,
          maxParkingFee: this.maxParkingFee,
          memo: this.memo,
          realFree: this.realFree
        }
      });
    },
    getParkingPaymentConfigList() {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          configType: 3
        })
        .then(res => {
          let data = res.data.data;
          if (data) {
            let configData = data[0];
            this.code = configData.code;
            this.unitPrice = configData.unitPrice;
            this.freeTime = configData.freeTime;
            this.maxParkingFee = configData.maxParkingFee;
            this.memo = configData.memo;
            this.realFree = !configData.realFree
          }
        })
        .catch(errorHandler("获取配置数据失败"));
    }
  }
};
</script>

<style scoped>
.textBox {
  display: inline-block;
  width: 180px;
  text-align: right;
  vertical-align: top;
}
.main_right {
  text-align: left;
}

.flexBox {
  display: flex;
  justify-content: space-between;
}

.flexBox a {
  line-height: 58px;
  margin-right: 40px;
  cursor: pointer;
  color: #00a0e6;
}
.flexBox a:hover {
  color: #06b3ff;
}

.main_right ul {
  width: 80%;
  margin: 10px auto 0;
  line-height: 40px;
}

.main_right ul li {
  width: 100%;
  padding: 4px 0;
  margin-bottom: 10px;
}
.main_right ul li b {
  color: #48576a;
  font-weight: 400;
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 15px;
}

.main_right ul li span {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingConfig/ParkingTemporaryConfigCenter.vue